import { render, staticRenderFns } from "./change-psw.vue?vue&type=template&id=834988d2&scoped=true&"
import script from "./change-psw.vue?vue&type=script&lang=js&"
export * from "./change-psw.vue?vue&type=script&lang=js&"
import style0 from "./change-psw.vue?vue&type=style&index=0&id=834988d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834988d2",
  null
  
)

export default component.exports